import { useDroppable } from "@dnd-kit/core";

export function Droppable({ children }) {
  const { setNodeRef } = useDroppable({
    id: "droppable",
  });

  return <div ref={setNodeRef}>{children}</div>;
}
